module.exports = __webpack_public_path__ + "img/mysc@2x.16787fb2.png";